// File: src/lib/stores/theme-store.ts
// Purpose: Theme state management for InstaDev
// InstaDev - Theme Store

import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { STORAGE_KEYS } from '@/lib/constants'

interface ThemeStore {
  theme: 'light' | 'dark' | 'system'
  setTheme: (theme: 'light' | 'dark' | 'system') => void
  effectiveTheme: 'light' | 'dark'
  setEffectiveTheme: (theme: 'light' | 'dark') => void
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      theme: 'system',
      effectiveTheme: 'light',
      setTheme: (theme) => set({ theme }),
      setEffectiveTheme: (effectiveTheme) => set({ effectiveTheme }),
    }),
    {
      name: STORAGE_KEYS.THEME,
      partialize: (state) => ({ theme: state.theme }),
    }
  )
)